import type { ThemeConfig } from 'antd';

/** Per-component antd token overrides — kept separate from the global tokens so a later stage
 *  can tune one widget's density/spacing without touching the whole palette.
 *
 *  Deliberate hierarchy: structural surfaces (Card/Table/Layout) lean on the hairline border from
 *  `colorBorderSecondary` instead of a drop shadow — shadow is reserved for things that actually
 *  float above content (Modal/Drawer/Dropdown/Popover), so it still reads as elevation rather than
 *  decoration repeated on every box. */
export const themeComponents = {
  Layout: {
    headerBg: '#FFFFFF',
    siderBg: '#FFFFFF',
    bodyBg: '#F6F6F2',
    headerPadding: '0 16px',
  },
  Card: {
    borderRadiusLG: 12,
    boxShadowTertiary: 'none',
  },
  Table: {
    cellPaddingBlock: 8,
    headerBg: '#F6F6F2',
    headerColor: '#5B6560',
    borderColor: '#E2E4DC',
  },
  Menu: {
    itemBorderRadius: 8,
    itemSelectedBg: '#E4F2EA',
    itemSelectedColor: '#1E7A4C',
    itemHoverBg: '#F1F5F2',
    subMenuItemBg: 'transparent',
  },
  Modal: { borderRadiusLG: 12 },
  Drawer: { borderRadiusLG: 12 },
  Popover: { borderRadiusLG: 12 },
  Dropdown: { borderRadiusLG: 10 },
  Tabs: { itemSelectedColor: '#1E7A4C', inkBarColor: '#1E7A4C' },
  Badge: { colorError: '#C1392B' },
  Tag: { defaultBg: '#F1F5F2', defaultColor: '#3A4640' },
} satisfies ThemeConfig['components'];
